export const getIconStyles = completed => ({
  width: 20,
  height: 20,
  borderRadius: '50%',
  backgroundColor: ({ palette }) => (completed ? palette.success.dark : palette.primary.main),
  color: '#fff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const stepIconStyles = {
  color: ({ palette }) => palette.text.secondary,
};

export const stepperStyles = {
  '& .MuiStep-root': {
    flex: 1,
    paddingLeft: '4px',
    paddingRight: '4px',
  },

  '& .MuiStepLabel-labelContainer': {
    color: ({ palette }) => palette.text.placeholder,
  },

  '& .MuiStepLabel-label': {
    fontWeight: 'bold',
  },

  '& .MuiStepLabel-iconContainer': {
    paddingRight: '4px',
  },
};

export const connectorStyles = {
  '& .MuiStepConnector-line': {
    borderColor: ({ palette }) => palette.border.input,
    borderTopWidth: 4,
    borderRadius: 1,
    marginTop: '8px',
  },

  '&.Mui-active': {
    '& .MuiStepConnector-line': {
      borderColor: ({ palette }) => palette.primary.main,
    },
  },

  '&.Mui-completed': {
    '& .MuiStepConnector-line': {
      borderColor: ({ palette }) => palette.success.dark,
    },
  },
};
